import { createNames } from "../../utils";
export const getAceFormGroupNames = (id) => {
    return createNames(id, 'ACE-FORM-GROUP', 'ERRORS', 'HEADLINE');
};
//# sourceMappingURL=ace-form-group.get-names.js.map
